module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/bullet-a7be5a0f17d603f3beaa95074dfe6302.svg";